module.exports = __webpack_public_path__ + "img/大数据智能系统标题.72ebbe42.png";